import { render, staticRenderFns } from "./ShowPostulatedProject.vue?vue&type=template&id=55c9d6ce&scoped=true"
import script from "./ShowPostulatedProject.vue?vue&type=script&lang=js"
export * from "./ShowPostulatedProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c9d6ce",
  null
  
)

export default component.exports